<template>
    <div>
        <title-component></title-component>
        <div class="row">
            <div class="col">
                <card-title-component :title="$t('contacts.resultSection.title')"></card-title-component>
                <div class="card-content">
                </div>
            </div>
        </div>
        <div class="row filter-row">
            <div class="col-lg-12">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter"
                                      :placeholder="$t('contacts.searchSection.searchInputPlaceholder')"
                                      class="o-form"/>
                        <b-input-group-append>
                            <b-btn :disabled="!filter"
                                   class="o-button clear-button"
                                   @click="filter = ''">
                                {{$t('contacts.searchSection.clearButton')}}
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="add-contact-link">
                    <a href="javascript:void(0)" v-b-modal.add-contact-modal>
                        {{$t('contacts.addContactButton')}}
                    </a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-table id="contacts-table"
                         stacked="lg"
                         hover
                         small
                         fixed
                         :items="localContacts"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :total-rows="totalRows"
                         :fields="computedFields"
                         :filter="filter"
                         @filtered="onFiltered">
                    <template slot="HEAD_firstname" slot-scope="" class="o-thead">

                    </template>
                    <template slot="actions" slot-scope="row">
                        <a href="javascript:void(0)" @click.stop="deleteContact(row.item.id)">
                            <icon name="trash-o"></icon>
                        </a>
                        |
                        <a href="javascript:void(0)" v-if="!row.item.onGuestlist"
                           @click.stop="putOnGuestlist(row.item)">
                            {{$t('contacts.resultSection.table.putOnAction')}}
                        </a>
                        <a href="javascript:void(0)" v-if="row.item.onGuestlist"
                           @click.stop="removeFromGuestlist(row.item)">
                            {{$t('contacts.resultSection.table.removeFromAction')}}
                        </a>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <b-pagination align="center"
                              size="sm"
                              :total-rows="totalRows"
                              v-model="currentPage"
                              :per-page="perPage">
                </b-pagination>
            </div>
        </div>
        <div class="row">
            <div class="col button-div">
                <b-button class="delete-all-button o-button" v-on:click="deleteAllContactsDialog" :disabled="contacts.length < 1">
                    {{$t('contacts.deleteAllButton')}}
                </b-button>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="add-contact-link">
                    <a href="javascript:void(0)" v-b-modal.add-contact-modal>
                        {{$t('contacts.addContactButton')}}
                    </a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <card-title-component :title="$t('contacts.qrSection.title')"></card-title-component>
                <div class="card-content">
                    <div class="app-instructions">
                        {{$t('contacts.qrSection.description')}}
                    </div>
                    <div class="store-badges">
                        <a href="https://itunes.apple.com/us/app/omyfu/id1423062463?ls=1&mt=8" target="_blank"><img src="../assets/images/icons/app_store_badge.png" height="40px"></a>
                        <a href="https://play.google.com/store/apps/details?id=com.omyfu.androidApp&hl=de" target="_blank"><img src="../assets/images/icons/google_play_badge_bw.png" height="40px"></a>
                    </div>
                    <div>
                        <qrcode :value="idToken" :options="{ size: 400 }"></qrcode>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="add-contact-modal" ref="add-contact-modal"
                 ok-title="Speichern"
                 cancel-title="Abbrechen"
                 :hide-header=true
                 :hide-footer=true>
            <add-contact-component></add-contact-component>
        </b-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        CONTACTS_ACTION_DELETE_ALL_CONTACTS,
        CONTACTS_ACTION_DELETE_CONTACT,
        CONTACTS_ACTION_GET_CONTACTS,
        CONTACTS_ACTION_UPDATE_CONTACT,
        CONTACTS_GETTER,
        CONTACTS_MUTATION_SINGLE_ENTRY,
        CONTACTS_NAMESPACE
    } from '../store/modules/contacts-types'
    import {AUTH_ACTION_REQUEST_IDTOKEN, AUTH_GETTER_IDTOKEN, AUTH_NAMESPACE} from '../store/modules/auth-types'
    import CardTitleComponent from './ui/card/CardTitleComponent'
    import TitleComponent from './shared/TitleComponent'
    import AddContactComponent from './contacts/AddContactComponent'
    import 'vue-awesome/icons/trash-o'
    import Icon from 'vue-awesome/components/Icon'
    import i18n from '../assets/i18n/lang'
    import VueQrcode from '@xkeshi/vue-qrcode'
    import Vue from 'vue'

    export default {
        name: 'Contacts',
        metaInfo () { return {title: i18n.t('contacts.meta')} },
        components: {
            'card-title-component': CardTitleComponent,
            'title-component': TitleComponent,
            'add-contact-component': AddContactComponent,
            'icon': Icon,
            'qrcode': VueQrcode
        },
        data () {
            return {
                currentPage: 1,
                perPage: 50,
                filter: '',
                totalRows: 0
            }
        },
        computed: {
            computedFields: function () {
                let fields = [
                    {key: 'firstname', label: i18n.t('contacts.resultSection.table.firstnameCol'), sortable: true},
                    {key: 'name', label: i18n.t('contacts.resultSection.table.lastnameCol'), sortable: true},
                    {
                        key: 'phone',
                        label: i18n.t('contacts.resultSection.table.phoneCol'),
                        sortable: false,
                        'class': 'text-center'
                    },
                    {key: 'actions', label: ''}
                ]
                return fields
            },
            ...mapGetters(CONTACTS_NAMESPACE, {
                contacts: CONTACTS_GETTER,
                idToken: AUTH_GETTER_IDTOKEN
            }),
            ...mapGetters(AUTH_NAMESPACE, {
                idToken: AUTH_GETTER_IDTOKEN
            }),
            localContacts: {
                get () { return this.contacts },
                set (value) { this.updateContacts({contacts: value}) }
            }
        },
        methods: {
            ...mapMutations(CONTACTS_NAMESPACE, {
                updateContacts: CONTACTS_MUTATION_SINGLE_ENTRY
            }),
            ...mapActions(CONTACTS_NAMESPACE, {
                loadContacts: CONTACTS_ACTION_GET_CONTACTS,
                deleteContact: CONTACTS_ACTION_DELETE_CONTACT,
                updateContact: CONTACTS_ACTION_UPDATE_CONTACT,
                deleteAllContacts: CONTACTS_ACTION_DELETE_ALL_CONTACTS
            }),
            ...mapActions(AUTH_NAMESPACE, {
                requestIdToken: AUTH_ACTION_REQUEST_IDTOKEN
            }),
            onFiltered (filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            putOnGuestlist (item) {
                this.updateContact({
                    id: item.id,
                    onGuestlist: true
                })
            },
            removeFromGuestlist (item) {
                this.updateContact({
                    id: item.id,
                    onGuestlist: false
                })
            },
            deleteAllContactsDialog () {
                Vue.swal({
                    title: i18n.t('feedback.deleteAllContactsConfirmation.title'),
                    text: i18n.t('feedback.deleteAllContactsConfirmation.text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'swal-confirm-button',
                    cancelButtonText: i18n.t('feedback.deleteAllContactsConfirmation.cancelButton'),
                    cancelButtonClass: 'swal-cancel-button',
                    confirmButtonText: i18n.t('feedback.deleteAllContactsConfirmation.confirmButton'),
                    buttonsStyling: false
                }).then((result) => {
                    if (result.value) {
                        this.deleteAllContacts()
                    }
                })
            }
        },
        created () {
            this.loadContacts()
                .then(() => { this.totalRows = this.localContacts.length })
                .catch((error) => { console.log(error) })
            this.requestIdToken()
                .then(() => {})
                .catch((error) => { console.log(error) })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';

    .filter-row {
        padding-bottom: 20px;
    }

    .delete-all-button {
        border-radius: 0;
        border: 0px;
        float: right;
    }

    .clear-button {
        background-color: $omyfu-yellow;
    }

    .add-contact-link {
        padding-top: 40px;
        text-align: right;
        text-decoration: underline;
    }

    .store-badges {
        float: left;
        padding-top: 20px;
    }
    .app-instructions {
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/ContactsComponent.vue